
export default {
  name: 'ClientError',
  layout: 'withoutBanners',
  props: {
    error: {
      type: Object,
      required: true
    }
  },

  computed: {
    is404() {
      return this.error?.statusCode === 404
    },

    message() {
      return this.is404 ? this.$t('pages.error.no-page') : this.error?.message
    }
  },

  mounted() {
    this.$sentry.captureMessage('Page 404')
  }
}
